import loadable from '@loadable/component';

export default loadable(
  () =>
    import(
      /* webpackChunkName: "__virtual-braindate-overlay" */
      './VirtualBraindateProvider/VirtualBraindateProvider'
    ),
);
